import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useModal } from '../../../context/ModalContext';
import ConfirmAlert from '../alert/ConfirmAlert';

type AlertConfig = {
  title: string;
  description: string;
  buttonText: string;
  confirm?: () => void;
  cancle?: () => void;
  cancleButtonText?: string;
};

function UserAlert() {
  const navigate = useNavigate();
  const location = useLocation();
  const { modal, modalDispatch } = useModal();
  const type = modal.userAlert.type;

  if (!modal.userAlert.open || !type) return null;

  const data: Record<string, AlertConfig> = {
    guest: {
      title: '로그인 후 이용이 가능합니다.',
      description: '로그인을 하시겠습니까?',
      buttonText: '로그인 하기',
      confirm: () => {
        navigate('/login');
      },
    },
    free: {
      title: '요금제 구매 후 이용이 가능합니다.',
      description: '요금제를 구매하고 땅집고옥션 서비스를 이용해보세요!',
      buttonText: '요금제 보러가기',
      confirm: () => {
        navigate('/payment/plan');
      },
    },
    local: {
      title: '이용중인 상품으로 열람할 수 없는 기능입니다.',
      description:
        '요금제를 업그레이드하고 더 자유롭게 땅집고옥션 서비스를 이용해보세요!',
      buttonText: '요금제 업그레이드',
      confirm: () => {
        navigate('/payment/plan');
      },
    },
    quotaDepleted: {
      title:
        '이번 달 이용권을 다 쓰셨어요.\n새 이용권은 다음 달에 자동으로 들어와요.',
      description:
        '이용권에 대해 궁금한 점이 있으시면 고객센터로 문의해 주세요.',
      buttonText: '확인',
      cancleButtonText: '1:1 문의하기',
      cancle: () => {
        modalDispatch({ type: 'I' });
      },
    },
    quotaDepletedExpiring: {
      title: '이번 달 이용권을 다 쓰셨어요.\n요금제가 곧 끝나요.',
      description: '다음 달에도 계속 이용하시려면 요금제를 연장해 주세요.',
      buttonText: '요금제 보러가기',
      confirm: () => {
        navigate('/payment/plan');
      },
    },
  };

  const { title, description, buttonText, confirm, cancle, cancleButtonText } =
    data[type];

  const handleClose = () => {
    if (location.pathname.includes('/detail')) {
      modalDispatch({ type: 'USER_ALERT_CLOSE_DETAIL' });
    } else {
      modalDispatch({ type: 'USER_ALERT_CLOSE' });
    }
  };
  return (
    // <Container
    //   onClick={(e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     modalDispatch({ type: 'USER_ALERT_CLOSE' });
    //   }}
    // >
    //   <Inner onClick={(e) => e.stopPropagation()}>
    //     <TextContainer>
    //       <Title>{title}</Title>
    //       <Description>{description}</Description>
    //     </TextContainer>
    //     <ButtonContainer>
    //       <Button
    //         onClick={() => {
    //           if (cancle) {
    //             cancle();
    //           }
    //           modalDispatch({ type: 'USER_ALERT_CLOSE' });
    //         }}
    //       >
    //         {cancleButtonText ?? '닫기'}
    //       </Button>
    //       <ConfirmButton
    //         onClick={() => {
    //           if (confirm) {
    //             confirm();
    //           }
    //           handleClose();
    //         }}
    //       >
    //         {buttonText}
    //       </ConfirmButton>
    //     </ButtonContainer>
    //   </Inner>
    // </Container>
    <ConfirmAlert
      title={title}
      desc={description}
      grayButtonText={cancleButtonText ?? '닫기'}
      blueButtonText={buttonText}
      onGrayClick={() => {
        if (cancle) {
          cancle();
        }
      }}
      onBlueClick={() => {
        if (confirm) {
          confirm();
        }
      }}
      onClose={handleClose}
    />
  );
}

export default UserAlert;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 328px;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 18px;
  color: #222222;
  margin: 0;
`;

const Description = styled(Title)`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
`;
const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: #70737c14;
  cursor: pointer;
  border: none;

  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #616161;
  white-space: nowrap;
`;

const ConfirmButton = styled(Button)`
  background-color: #008aff;
  color: #ffffff;
`;
